import React from 'react';
import PropTypes from 'prop-types';

import { withPrefix } from 'gatsby-link';

const QuickStartPdfLink = ({ title }) => (
  <a href={withPrefix('/welcome_to_online_practice_v2.pdf')} download="Online Practice quick start guide" target="_blank">{title}</a>
);

QuickStartPdfLink.propTypes = {
  title: PropTypes.string,
};

export default QuickStartPdfLink;



// WEBPACK FOOTER //
// ./src/components/QuickStartPdfLink/QuickStartPdfLink.js